/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class LiveContentProvider
 * @hideconstructor
 * @classdesc API provider class to create LiveWidget ContentAPI instances
 */
define([
	'../../../lib/@waca/dashboard-common/dist/core/APIFactory',
	'../../../lib/@waca/dashboard-common/dist/api/ContentProviderAPI'
], (APIFactory, ContentProviderAPI) => {

	class LiveContentProvider {

		constructor(options) {
			this._api = APIFactory.createAPI(this, [ContentProviderAPI]);
			this.base = options.features['BaseContentProvider'];
			this.datasources = options.features['DataSources'];
			options.features['ContentFactory'].registerProvider(this._api);
		}

		getAPI() {
			return this._api;
		}

		getTypeList() {
			return ['widget.live'];
		}

		addModel(content, extra, options) {
			const widgetSpec = content && content.spec;
			if (widgetSpec) {
				this._addDataSource(widgetSpec, options);
			}
			return this.base.addModel(...arguments);
		}

		createContent() {
			return this.base.createContent(...arguments);
		}

		_addDataSource(widget, options) {
			const data = widget && widget.data;
			if (data && data.dataViews && data.dataViews.length) {
				data.dataViews.forEach((view) => {
					if (view.model) {
						view.modelRef = this.datasources.addDataSource(view.model, false, options);
						delete view.model;
					}
				});
			}
		}
	}
	return LiveContentProvider;
});
